module.exports = __webpack_public_path__ + "static/media/privacyPolicyRaw.7610464a.md";